import React from 'react';
import LossReasonsSettings from '../features/settings/loss-reasons/LossReasonsSettings';

const LossReasonsSettingsPage: React.FC = () => {
    return <LossReasonsSettings />;
};

export default LossReasonsSettingsPage;
